import React, { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../components/Form/Field'

import { formatDv360ViewabilityTargetingOptions } from '../../../../../lineItemHelpers'

import {
  clearGetDv360ViewabilityTargetingOptions,
  getDv360ViewabilityTargetingOptions
} from '../../../../../../../modules/actions/dv360Constants'
import { selectedDV360AdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'
import {
  dv360ViewabilityTargetingOptionsSelector,
  getDv360ViewabilityTargetingOptionsIsLoadingSelector
} from '../../../../../../../modules/selectors/dv360Constants'

import { VIEWABILITY, VIEWABILITY_OPTION } from '../../fields'
import { OPTION_NO, OPTION_YES } from '../../../../../../../constants/forms'

const stepFields = [VIEWABILITY]

const ViewabilityStep = ({ formik, handleStepChange }) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const dv360ViewabilityTargetingOptions = useSelector(dv360ViewabilityTargetingOptionsSelector)
  const getDv360ViewabilityTargetingOptionsIsLoading = useSelector(getDv360ViewabilityTargetingOptionsIsLoadingSelector)

  const { values, setFieldValue, errors, touched } = formik

  const viewabilityError = errors[VIEWABILITY]
  const viewabilityTouched = touched[VIEWABILITY]

  const formattedViewabilityTargetingOptions = useMemo(() => {
    return formatDv360ViewabilityTargetingOptions(dv360ViewabilityTargetingOptions)
  }, [dv360ViewabilityTargetingOptions])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  useEffect(() => {
    dispatch(
      getDv360ViewabilityTargetingOptions({
        account: selectedAdAccountId
      })
    )
  }, [dispatch, selectedAdAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearGetDv360ViewabilityTargetingOptions())
    }
  }, [dispatch])

  return (
    <Step stepTitle="Would you like to set an Active View Predicted Viewability?" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={VIEWABILITY_OPTION + OPTION_NO}
        name={VIEWABILITY_OPTION}
        value={OPTION_NO}
        selectedValue={values[VIEWABILITY_OPTION]}
        label={t('No')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={VIEWABILITY_OPTION + OPTION_YES}
        name={VIEWABILITY_OPTION}
        value={OPTION_YES}
        selectedValue={values[VIEWABILITY_OPTION]}
        label={t('Yes')}
        error={viewabilityError}
        touched={viewabilityTouched}
      >
        <Field
          placeholder={t('Viewability')}
          options={formattedViewabilityTargetingOptions}
          name={VIEWABILITY}
          value={values[VIEWABILITY]}
          isLoading={getDv360ViewabilityTargetingOptionsIsLoading}
          formik={formik}
        />
      </RadioBlock>
    </Step>
  )
}

export default ViewabilityStep
